import React from "react";
import { motion } from "framer-motion";
import {
  FaBookReader,
  FaBookOpen,
  FaLaptop,
  FaGlobe,
  FaCheckCircle,
} from "react-icons/fa";

import libraryImg from "../assets/library.jpeg";

const Library = () => {
  return (
    <section className="bg-slate-50">

      {/* HERO */}

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-16">

        <div className="grid lg:grid-cols-2 gap-14 items-center">

          {/* LEFT CONTENT */}

          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
          >

            <span className="inline-flex items-center rounded-full bg-yellow-100 text-yellow-700 px-5 py-2 text-sm font-semibold tracking-wide">

              LIBRARY

            </span>

            <h1 className="mt-6 text-4xl lg:text-5xl font-extrabold leading-tight text-[#07294d]">

              Today, a Reader,
              <br />

              <span className="text-yellow-500">

                Tomorrow, a Leader

              </span>

            </h1>

            <p className="mt-8 text-gray-600 text-lg leading-9">

              Library is the treasure houses of wit, wisdom and
              academic wealth. The school maintains well stocked
              library to cater to the demands of students in the
              nursery, primary, secondary and senior secondary wings.

            </p>

            <p className="mt-6 text-gray-600 text-lg leading-9">

              It is indeed the pride of our school, with nearly
              seven thousand books of varied genres available
              for students and teachers.

            </p>

          </motion.div>

          {/* ONLY IMAGE */}

          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
          >

            <div className="relative overflow-hidden rounded-[35px] shadow-2xl">

              <img
                src={libraryImg}
                alt="Library"
                className="w-full h-[520px] object-cover"
              />

              <div className="absolute inset-0 bg-gradient-to-t from-[#07294d]/50 to-transparent"></div>

              <div className="absolute bottom-6 left-6 bg-white/90 backdrop-blur-md rounded-2xl px-6 py-5">

                <div className="flex items-center gap-4">

                  <div className="w-14 h-14 rounded-xl bg-yellow-400 text-white flex items-center justify-center text-2xl">

                    <FaBookReader />

                  </div>

                  <div>

                    <h3 className="font-bold text-[#07294d]">

                      7000+ Books

                    </h3>

                    <p className="text-sm text-gray-600">

                      Academic & Reference Collection

                    </p>

                  </div>

                </div>

              </div>

            </div>

          </motion.div>

        </div>

      </section>

      {/* CONTENT */}

      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-20">

        <motion.div
          initial={{ opacity: 0, y: 35 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: .7 }}
          viewport={{ once: true }}
          className="bg-white rounded-[35px] shadow-xl p-10 lg:p-14"
        >

          <h2 className="text-4xl font-bold text-[#07294d]">

            School Library

          </h2>

          <div className="w-24 h-1 bg-yellow-500 rounded-full mt-5 mb-8"></div>

          <p className="text-gray-600 leading-9 text-lg mb-8">

            We at Cambridge strongly believe that technology will
            never be able to replace books though it may well alter
            its appearance. A library empowered with thousands of
            articles and books is provided to all the students.

          </p>

          <p className="text-gray-600 leading-9 text-lg mb-8">

            A huge spectrum of books authored by acclaimed writers
            of various genres is available to children at the
            Cambridge Library. This encourages and inculcates in
            them a love for reading that not only provides sheer joy
            but also further develops and enhances many skills.

          </p>

          <p className="text-gray-600 leading-9 text-lg">

            Further, the growth of Information and Communication
            Technology (ICT) in society is reflected in government
            policies to encourage the use of ICT in education and
            the development of educational multimedia.

          </p>

        </motion.div>

      </section>
            {/* ================= LIBRARY FEATURES ================= */}

      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-20">

        <div className="text-center mb-12">

          <span className="uppercase tracking-[3px] text-yellow-500 font-semibold">
            Library Facilities
          </span>

          <h2 className="text-4xl font-bold text-[#07294d] mt-4">
            Everything Students Need
          </h2>

        </div>

        <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-6">

          {[
            {
              icon: <FaBookOpen />,
              title: "7000+ Books",
              desc: "Extensive collection of books available for students and teachers.",
            },
            {
              icon: <FaBookReader />,
              title: "Reading Culture",
              desc: "Encouraging a lifelong love for reading and knowledge.",
            },
            {
              icon: <FaLaptop />,
              title: "ICT Support",
              desc: "Technology and multimedia resources support modern learning.",
            },
            {
              icon: <FaGlobe />,
              title: "Knowledge Resources",
              desc: "A wide variety of books from different genres and authors.",
            },
            {
              icon: <FaBookReader />,
              title: "Academic Learning",
              desc: "Supports students from Nursery to Senior Secondary.",
            },
            {
              icon: <FaCheckCircle />,
              title: "Learning Environment",
              desc: "A peaceful atmosphere that promotes reading and self-learning.",
            },

          ].map((item, index) => (

            <motion.div
              key={index}
              initial={{ opacity: 0, y: 25 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.08 }}
              viewport={{ once: true }}
              whileHover={{ y: -6 }}
              className="bg-white rounded-3xl p-6 shadow-md hover:shadow-xl transition"
            >

              <div className="w-14 h-14 rounded-2xl bg-yellow-100 text-yellow-500 flex items-center justify-center text-2xl mb-5">

                {item.icon}

              </div>

              <h3 className="text-xl font-bold text-[#07294d]">

                {item.title}

              </h3>

              <p className="text-gray-600 mt-3 leading-7">

                {item.desc}

              </p>

            </motion.div>

          ))}

        </div>

      </section>

      {/* ================= STATS ================= */}

      <section className="bg-[#07294d] py-16">

        <div className="max-w-7xl mx-auto px-6">

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">

            {[
              {
                number: "7000+",
                title: "Books",
              },
              {
                number: "Nursery",
                title: "To Senior Secondary",
              },
              {
                number: "ICT",
                title: "Learning Support",
              },
              {
                number: "Daily",
                title: "Library Access",
              },

            ].map((item, index) => (

              <motion.div
                key={index}
                initial={{ opacity: 0, y: 25 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.08 }}
                viewport={{ once: true }}
                className="bg-white rounded-3xl p-7 text-center"
              >

                <h2 className="text-4xl font-extrabold text-[#07294d]">

                  {item.number}

                </h2>

                <p className="text-gray-600 mt-3">

                  {item.title}

                </p>

              </motion.div>

            ))}

          </div>

        </div>

      </section>

    </section>
  );
};

export default Library;